import React from "react";
import { Theme, createTheme } from "@mui/material/styles";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router";
import AppIcon from "./carepath_logo_and_name.svg?react";

const Logo = React.forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div ref={ref}>
      <AppIcon />
    </div>
  );
});
Logo.displayName = "Logo";

const LinkBehavior = React.forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, "to"> & { href: RouterLinkProps["to"] }
>((props, ref) => {
  const { href, ...other } = props;
  // Map href (Material UI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />;
});
LinkBehavior.displayName = "LinkBehavior";
const favicon =
  "data:image/png;base64,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";

const palette = {
  text: {
    primary: "#081e43",
    secondary: "#081e4399",
    disabled: "#081E4361",
  },
  primary: {
    main: "#081E43",
    dark: "#05152E",
    light: "#394B68",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#AAA1FD",
    dark: "#745DE5",
    light: "#CDC6FE",
    contrastText: "#081E43",
  },
  action: {
    active: "#AAA1FD",
    activatedOpacity: 1,
    hover: "#745DE50A",
    hoverOpacity: 0.04,
    selected: "#edeafb",
    selectedOpacity: 0.12,
    focus: "#745DE529",
    focusOpacity: 0.16,
    disabledBackground: "#0000001F",
    disabled: "#00000061",
    disabledOpacity: 0.38,
  },
  error: {
    main: "#FB6A76",
    dark: "#EC0031",
    light: "#FF969D",
    contrastText: "#081E43",
  },
  warning: {
    main: "#FFBD5B",
    dark: "#C55011",
    light: "#fdf5db",
    contrastText: "#081E43",
  },
  info: {
    main: "#65ABE8",
    dark: "#226BC0",
    light: "#EBE9FF",
    contrastText: "#081E43",
  },
  success: {
    main: "#3EC490",
    dark: "#007840",
    light: "#81D4B0",
    contrastText: "#081E43",
  },
  background: {
    default: "#FFFFFF",
    secondary: "#FAFAFF",
    paper: "#FFFFFF",
  },
  divider: "#081e431e",
};
const theme = createTheme({
  custom: {
    logo: <Logo />,
    favicon: favicon,
    title: "Lumonus AI - Manage",
  },
  palette: palette,
  typography: {
    fontFamily: "Poppins",
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
      styleOverrides: {
        root: {
          ":focus-visible": {
            outlineColor: palette.secondary.main,
          },
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: "black",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        // white text when hovered
        contained: {
          ":hover": { color: "white" },
        },
        containedInherit: {
          ":hover": { color: "unset" },
        },
        // darken text of outlined and text variants
        outlinedError: { color: palette.error.dark },
        outlinedInfo: { color: palette.info.dark },
        outlinedWarning: { color: palette.warning.dark },
        outlinedSuccess: { color: palette.success.dark },
        outlinedSecondary: { color: palette.secondary.dark },
        textError: { color: palette.error.dark },
        textInfo: { color: palette.info.dark },
        textWarning: { color: palette.warning.dark },
        textSuccess: { color: palette.success.dark },
        textSecondary: { color: palette.secondary.dark },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        // darken error helper text
        root: {
          "&.Mui-error": {
            color: palette.error.dark,
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          ":hover": { color: "white" },
          ":is(.MuiFab-colorInherit, .MuiFab-default):hover": {
            color: "inherit",
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: palette.secondary.main,
          color: palette.primary.dark,
        },
      },
    },
    MuiBadge: {
      styleOverrides: {
        // "default" colours are error colours
        badge: {
          ":not([class*='MuiBadge-color'])": {
            backgroundColor: palette.error.main,
            color: palette.error.contrastText,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        // white text when hovered
        filled: {
          "&.MuiChip-clickable:hover": { color: "white" },
          "&.MuiChip-colorDefault:hover": { color: "unset" },
        },
        root: {
          // all avatar colour variants use text.primary besides primary
          ".MuiChip-avatar": {
            color: palette.text.primary,
          },
          ".MuiChip-avatarColorPrimary": {
            color: palette.primary.contrastText,
            backgroundColor: palette.primary.light,
          },
          // avatar background colours are color.light
          ".MuiChip-avatarColorSecondary": {
            backgroundColor: palette.secondary.light,
          },
          ".MuiChip-avatarColorInfo": {
            backgroundColor: palette.info.light,
          },
          ".MuiChip-avatarColorWarning": {
            backgroundColor: palette.warning.light,
          },
          ".MuiChip-avatarColorError": {
            backgroundColor: palette.error.light,
          },
          ".MuiChip-avatarColorDefault": {
            // except default
            backgroundColor: palette.secondary.main,
          },
          // arbitrary delete icon colour :(
          ".MuiChip-deleteIconColorDefault": {
            color: "#430098",
            opacity: 0.26,
          },
          // outlined variant uses dark version of respective colour
          "&.MuiChip-outlinedPrimary": {
            color: palette.primary.dark,
          },
          "&.MuiChip-outlinedSecondary": {
            color: palette.secondary.dark,
          },
          "&.MuiChip-outlinedInfo": {
            color: palette.info.dark,
          },
          "&.MuiChip-outlinedWarning": {
            color: palette.warning.dark,
          },
          "&.MuiChip-outlinedError": {
            color: palette.error.dark,
          },
          "&.MuiChip-outlinedDefault": {
            color: palette.primary.dark,
            borderColor: palette.action.active,
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          // left line and background for selected
          ".MuiListItemButton-root.Mui-selected": {
            backgroundColor: palette.secondary.light,
            borderLeft: `4px solid ${palette.primary.main}`,
          },
          // border radius for all top-level list items
          ".MuiListItem-root, .MuiListItemButton-root": {
            borderRadius: "4px",
          },
          ".MuiListItem-gutters, .MuiListItemButton-gutters": {
            paddingLeft: "12px",
            paddingRight: 0,
          },
          // get rid of jank overlay radius onClick
          ".Mui-selected>.MuiTouchRipple-root": {
            borderRadius: "0px 4px 4px 0px",
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          // close icon of filled variant must be dark
          "&.MuiAlert-filled.MuiAlert-closeIcon": {
            color: palette.text.primary,
          },
        },
      },
    },
    // prefer secondary colour for progress
    MuiLinearProgress: {
      defaultProps: {
        color: "secondary",
      },
    },
    MuiCircularProgress: {
      defaultProps: {
        color: "secondary",
      },
    },
    // snackbar action text should be secondary.light
    MuiSnackbarContent: {
      styleOverrides: {
        action: {
          color: palette.secondary.light,
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          // text and border colours
          ".MuiPaginationItem-outlinedSecondary": {
            borderColor: "#43009839", // totally arbitrary opacity, love it
            "&.Mui-selected": {
              color: palette.secondary.dark,
            },
          },
        },
      },
    },
    MuiStepLabel: {
      // step label uses dark version of color
      styleOverrides: {
        label: {
          "&.Mui-error": {
            color: palette.error.dark,
          },
        },
      },
    },
    MuiStepIcon: {
      // step icons must have 24px min width
      styleOverrides: {
        root: {
          minWidth: "24px",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        // tab text is darker when secondary
        textColorSecondary: {
          "&.Mui-selected": {
            color: palette.secondary.dark,
          },
          "&.Mui-selected svg": {
            color: palette.secondary.main,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        // tab indicator is darker when secondary
        indicator: ({ ownerState: { indicatorColor } }) => ({
          backgroundColor:
            indicatorColor === "secondary"
              ? palette.secondary.dark
              : palette.primary.main,
        }),
      },
    },
    MuiIconButton: {
      styleOverrides: {
        // default colour is primary
        root: {
          ":not([class*='MuiIconButton-color'])": {
            color: palette.primary.main,
          },
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          "&.MuiAutocomplete-popper>.MuiAutocomplete-paper": {
            ".Mui-selected": {
              backgroundColor: palette.action.focus,
              ":hover": {
                backgroundColor: palette.action.focus,
              },
            },
          },
        },
      },
    },
  },
});

export default theme;
